import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/timberbuyer/')({
  loader: () => {
    redirect({
      to: '/timberbuyer/search',
      throw: true,
    })
  },
  staticData: {
    breadcrumb: 'Tømmerkjøper',
  },
})
